(() => {
  const openLinkedFaqQuestion = () => {
    const { pathname, hash } = window.location;
    if (!pathname.includes('/pages/') || !pathname.includes('frequently-asked-questions') || !hash) {
      return;
    }

    const hashId = hash.slice(1);
    const questionPanel = document.getElementById(hashId);
    if (!questionPanel?.classList.contains('Accordion-answer')) {
      return;
    }

    const listGroup = questionPanel.closest('.Accordion-list');
    if (listGroup) {
      const groupTrigger = document.querySelector(`.Accordion [href="#${listGroup.id}"]`);
      if (groupTrigger?.getAttribute('aria-expanded') !== 'true') {
        groupTrigger?.click();
      }
    }

    const questionTrigger = document.querySelector(`.Accordion [aria-controls="${hashId}"]`);
    if (questionTrigger) {
      if (questionTrigger.getAttribute('aria-expanded') !== 'true') {
        questionTrigger.click();
      }
      setTimeout(() => questionPanel.scrollIntoView({ block: 'center' }), 1);
    }
  };

  // Deferred so it runs after theme.js binds the Accordion click handlers on DOMContentLoaded.
  const deferredInit = () => setTimeout(openLinkedFaqQuestion, 0);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInit);
  } else {
    deferredInit();
  }

  // Links to another question on the already-loaded FAQ page only change the
  // hash — no reload, no DOMContentLoaded — so react to hash changes too.
  window.addEventListener('hashchange', openLinkedFaqQuestion);

  // Re-navigating to the exact same URL (hash included) fires no hashchange
  // at all; the Navigation API is the only thing that observes it.
  window.navigation?.addEventListener('navigate', (event) => {
    if (event.destination.sameDocument) {
      setTimeout(openLinkedFaqQuestion, 0);
    }
  });
})();
